import { desktopAddressKey } from '../helpers/storage';
import { useAppSelector } from '../store';
import { IUserInfo } from '../store/reducers/user';
import { returnRawValue, useLocalStorage } from './useLocalStorage';

const useGetUserAddress = () => {
  const userInfo: IUserInfo = useAppSelector((state) => state.user);
  const [linkedDeskTopAddress] = useLocalStorage(desktopAddressKey, undefined, {
    serialize: returnRawValue,
    deserialize: returnRawValue,
  });

  const userAddress = (linkedDeskTopAddress as string) ?? userInfo.walletAddress;
  return {
    address: userAddress,
  };
};

export default useGetUserAddress;
